<script lang="ts">
  import { onMount, onDestroy } from 'svelte';
  import { SubscriptionTestService } from '$lib/services/subscription/SubscriptionTestService';
  
  let testService: SubscriptionTestService;
  
  onMount(() => {
    // Only initialize in development mode
    if (import.meta.env.DEV) {
      testService = SubscriptionTestService.getInstance();
      
      // Listen for test commands from Electron menu
      if (window.api?.onMenuAction) {
        // Plan switching
        window.api.onMenuAction('test:switch-plan', async (plan: string) => {
          await testService.switchPlan(plan);
        });
        
        // Trial management
        window.api.onMenuAction('test:expire-trial', async () => {
          await testService.expireTrial();
        });
        
        window.api.onMenuAction('test:reset-trial', async () => {
          await testService.resetTrial();
        });
        
        window.api.onMenuAction('test:clear-trial-expired-modal', async () => {
          await testService.showTrialExpiredModal();
        });
        
        // Modal testing
        window.api.onMenuAction('test:show-modal', async (modalType: string) => {
          await testService.testModal(modalType);
        });
        
        // Usage simulation
        window.api.onMenuAction('test:simulate-usage', async (data: { type: 'grammar' | 'ai', count: number }) => {
          await testService.simulateUsage(data.type, data.count);
        });
        
        window.api.onMenuAction('test:show-usage-stats', async () => {
          await testService.showUsageStats();
        });
        
        // License testing
        window.api.onMenuAction('test:generate-license', async () => {
          testService.generateTestLicense();
        });
        
        window.api.onMenuAction('test:use-license', async (data: { type: 'monthly' | 'yearly', key: string }) => {
          await testService.usePredefinedLicense(data.type, data.key);
        });
        
        window.api.onMenuAction('test:input-license', async (data: { valid: boolean }) => {
          await testService.inputLicense(data.valid);
        });
        
        window.api.onMenuAction('test:remove-license', async () => {
          await testService.clearAllLicenses();
          await testService.refreshSubscriptionStatus();
        });
        
        window.api.onMenuAction('test:device-limit', async () => {
          await testService.testDeviceLimit();
        });
        
        // Trial period simulation
        window.api.onMenuAction('test:set-trial-days', async (days: number) => {
          await testService.setTrialDaysRemaining(days);
        });
        
        window.api.onMenuAction('test:set-trial-hours', async (hours: number) => {
          await testService.setTrialHoursRemaining(hours);
        });
        
        // Server testing
        window.api.onMenuAction('test:check-server', async () => {
          await testService.checkServerStatus();
        });
        
        window.api.onMenuAction('test:verify-license-server', async () => {
          await testService.verifyLicenseWithServer();
        });
        
        // Status display
        window.api.onMenuAction('test:show-subscription-status', async () => {
          await testService.showSubscriptionStatus();
        });
        
        window.api.onMenuAction('test:refresh-subscription', async () => {
          await testService.refreshSubscriptionStatus();
        });
        
        // Server trial testing
        window.api.onMenuAction('test:initialize-server-trial', async () => {
          await testService.initializeServerTrial();
        });
        
        window.api.onMenuAction('test:check-server-trial', async () => {
          await testService.checkServerTrialStatus();
        });
        
        window.api.onMenuAction('test:verify-server-trial', async () => {
          await testService.verifyServerTrial();
        });
        
        window.api.onMenuAction('test:simulate-reinstall', async () => {
          await testService.simulateReinstall();
        });
        
        window.api.onMenuAction('test:change-device-id', async () => {
          await testService.changeDeviceId();
        });
        
        window.api.onMenuAction('test:reset-server-trial', async () => {
          await testService.resetServerTrial();
        });
        
        window.api.onMenuAction('test:reset-all-server-trials', async () => {
          await testService.resetAllServerTrials();
        });
        
        window.api.onMenuAction('test:clear-local-cache', async () => {
          await testService.clearLocalTrialCache();
        });
        
        window.api.onMenuAction('test:force-reinitialize-trial', async () => {
          await testService.forceReinitializeTrial();
        });
      }
    }
  });
  
  onDestroy(() => {
    // Clean up event listeners if needed
  });
</script>

<!-- This component has no UI, it just handles test commands -->